(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var grid = document.getElementById('product-grid');
  if (!grid) return;
  var pager = document.getElementById('js-pagination');
  var noResults = document.getElementById('no-results');
  var filterBtns = document.querySelectorAll('.filter-btn');
  var allCards = Array.prototype.slice.call(grid.querySelectorAll('.product-card'));
  var perPage = parseInt(grid.dataset.perPage || '12', 10);
  if (isNaN(perPage) || perPage < 1) perPage = 12;

  var currentFilter = 'all';
  var currentMetal = 'all';
  var currentPage = 1;

  // Shopify caps how many products render per pass, so pull in the remaining
  // paginated pages and append them before wiring up the filters/pager.
  (function loadRemaining() {
    var seen = {};
    allCards.forEach(function(c) { seen[c.dataset.handle] = 1; });
    var page = 2;
    function next() {
      fetch(location.pathname + '?page=' + page, { credentials: 'same-origin' })
        .then(function(r) { return r.ok ? r.text() : ''; })
        .then(function(html) {
          if (!html) { finish(); return; }
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var cards = doc.querySelectorAll('#product-grid .product-card');
          var added = 0;
          cards.forEach(function(c) {
            if (seen[c.dataset.handle]) return;
            seen[c.dataset.handle] = 1;
            grid.appendChild(document.importNode(c, true));
            added++;
          });
          if (added > 0 && page < 12) { page++; next(); } else { finish(); }
        })
        .catch(function() { finish(); });
    }
    function finish() {
      allCards = Array.prototype.slice.call(grid.querySelectorAll('.product-card'));
      render();
    }
    next();
  })();

  function matched() {
    return allCards.filter(function(card) {
      var catOk = currentFilter === 'all' || (currentFilter === 'sale' ? card.dataset.sale === '1' : card.dataset.type === currentFilter);
      var metalOk = currentMetal === 'all' || card.dataset.metal === currentMetal;
      return catOk && metalOk;
    });
  }

  function render() {
    var list = matched();
    var total = list.length;
    var pages = Math.ceil(total / perPage);
    if (currentPage > pages) currentPage = pages || 1;

    // hide every card, then show only the current page slice of the filtered list
    allCards.forEach(function(c) { c.style.display = 'none'; });
    var start = (currentPage - 1) * perPage;
    var end = start + perPage;
    list.slice(start, end).forEach(function(c) { c.style.display = ''; });

    if (noResults) noResults.style.display = total === 0 ? 'block' : 'none';

    // build pager only when more than one page exists
    if (!pager) return;
    if (pages <= 1) { pager.innerHTML = ''; return; }

    var html = '';
    if (currentPage > 1) {
      html += '<a class="prev" data-page="' + (currentPage - 1) + '">&laquo; Previous</a>';
    }
    for (var i = 1; i <= pages; i++) {
      if (i === currentPage) {
        html += '<span class="current">' + i + '</span>';
      } else {
        html += '<a class="page" data-page="' + i + '">' + i + '</a>';
      }
    }
    if (currentPage < pages) {
      html += '<a class="next" data-page="' + (currentPage + 1) + '">Next &raquo;</a>';
    }
    pager.innerHTML = html;
  }

  // category filter buttons
  filterBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      filterBtns.forEach(function(b) { b.classList.remove('active'); });
      btn.classList.add('active');
      currentFilter = btn.dataset.filter;
      currentPage = 1;
      render();
    });
  });

  // metal filter buttons (combine with category filter)
  var metalBtns = document.querySelectorAll('.metal-btn');
  metalBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      metalBtns.forEach(function(b) { b.classList.remove('active'); });
      btn.classList.add('active');
      currentMetal = btn.dataset.metalFilter;
      currentPage = 1;
      render();
    });
  });

  // pager clicks (event delegation): change page within the SAME filter
  if (pager) {
    pager.addEventListener('click', function(e) {
      var link = e.target.closest('a[data-page]');
      if (!link) return;
      e.preventDefault();
      currentPage = parseInt(link.dataset.page, 10);
      render();
      var shop = document.getElementById('shop');
      if (shop) window.scrollTo({ top: shop.offsetTop - 70, behavior: 'smooth' });
    });
  }

  render();
});

// Buy it now from a homepage card: single-variant -> add + checkout; multi-variant -> open product page
function pcBuyNow(btn) {
  var card = btn.closest('.product-card');
  if (card.dataset.multi === '1') { window.location.href = card.dataset.url; return; }
  btn.disabled = true;
  btn.textContent = 'Processing…';
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: card.dataset.vid, quantity: 1 })
  })
  .then(function(r) { return r.json(); })
  .then(function() { window.location.href = '/checkout'; })
  .catch(function() { btn.textContent = 'Buy it now'; btn.disabled = false; });
}

  } catch(e) { console.error(e); }
})();
})();
